/**
 * Responsibility: Implement scheduler behavior for the engine layer.
 * Scope: Owns engine-layer concerns only; cross-layer orchestration is excluded.
 */
import { runSupervisorPass } from './supervisor-engine'
import { registerDefaultSupervisorChecks } from './checks'
import { dispatcher } from '../../app-states'
import { TOPICS } from "@anyquest/shared-core"
import * as gameStore from '../../game-store'

let handles: any[] = []
let periodicTimer: any = null

export function initSupervisorScheduler() {
  if (handles.length > 0) return // Already initialized
  registerDefaultSupervisorChecks()

  handles = [
    dispatcher.on(TOPICS.game.started, () => {
      triggerRun('game:started')
    }),
    dispatcher.on(TOPICS.game.loaded, () => {
      triggerRun('game:loaded')
    }),
    dispatcher.on(TOPICS.game.actionComplete, () => {
      triggerRun('game:actionComplete')
    }),
    dispatcher.on(TOPICS.world.ticked, () => {
      triggerRun('world:ticked')
    })
  ]

  // Periodic trigger in idle windows
  periodicTimer = setInterval(() => {
    // Only run periodic if we have an active game and it's not currently busy
    if (gameStore.state && !gameStore.isProcessing) {
      triggerRun('periodic_idle')
    }
  }, 60_000) // Every 1 minute
}

export function teardownSupervisorScheduler() {
  handles.forEach(h => dispatcher.off(h))
  handles = []
  if (periodicTimer) {
    clearInterval(periodicTimer)
    periodicTimer = null
  }
}

function triggerRun(reason: string) {
  const state = gameStore.state
  if (!state) return

  // Fire-and-forget
  runSupervisorPass(state, reason).catch(e => {
    console.error(`[Supervisor] Background run failed (${reason}):`, e)
  })
}
